import { useContent } from "@/context/ContentContext";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { VisionMission } from "@/components/landing/VisionMission";
import { AboutUs } from "@/components/landing/AboutUs";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { Gallery } from "@/components/landing/Gallery";
import { Registration } from "@/components/landing/Registration";
import { Location } from "@/components/landing/Location";
import { Contact } from "@/components/landing/Contact";
import { SmoothScroll } from "@/components/SmoothScroll";
import { FaWhatsapp } from "react-icons/fa";
import { Loader2 } from "lucide-react";

export default function PublicSite() {
  const { content, loading } = useContent();

  if (loading || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sky-50">
        <Loader2 className="w-10 h-10 text-sky-500 animate-spin" />
      </div>
    );
  }

  const wa = `https://wa.me/${content.contact.whatsapp}`;

  return (
    <SmoothScroll>
      <div className="App">
        <Header content={content} />
        <main>
          <Hero content={content} />
          <VisionMission content={content} />
          <AboutUs content={content} />
          <Pricing content={content} />
          <Testimonials content={content} />
          <Gallery content={content} />
          <Registration content={content} />
          <Location content={content} />
          <Contact content={content} />
        </main>

        <a
          href={wa}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Hubungi via WhatsApp"
          data-testid="floating-whatsapp"
          className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center shadow-xl shadow-green-500/40 hover:scale-110 transition-transform"
        >
          <FaWhatsapp className="w-7 h-7 text-white" />
          <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30" />
        </a>
      </div>
    </SmoothScroll>
  );
}
